<div *ngIf="loader" class="spinner">
  <nx-spinner nxSize="large"></nx-spinner>
</div>

<div *ngIf="!loader">
  <app-metadata-form (allValidChanged)="onAllValidChanged($event)" [documentMetadata]="documentMetadata"></app-metadata-form>

  <div [hidden]="!!documentMetadata.jadedui">
    <nx-file-uploader #documentUpload [(ngModel)]="documentMetadata!.file" [accept]="acceptableFormatForDocument" 
       [maxFileSize]="256 * 1024 * 1024" (ngModelChange)="onFileChange($event)">
        <nx-label size="small" class="nx-margin-bottom-3xs">Wählen Sie eine Datei zum Hochladen aus</nx-label>
        <nx-error>Das Dokument übersteigt das gültige Dateigrößenlimit. Bitte die Datei möglichst aufteilen und in kleineren Portionen hochladen.</nx-error>
        <nx-file-uploader-drop-zone class="nx-margin-bottom-m">
          <button nxButton="primary" type="button" nxFileUploadButton class="my-upload-button">
                <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>
              Datei hinzufügen
            </button>
        </nx-file-uploader-drop-zone>

    </nx-file-uploader>
  </div>
  <div nxRow class="position">
    <div nxCol="5">
    </div>
    <button
        nxButton="primary small"
        (click)="upload()"
        [disabled]="!((documentMetadata.jadedui || hasFile) && isFormValid)"
        type="button"
        class="my-search-button"
    >
      Importieren
    </button>
    </div>
</div>
